function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.004,0c-0.001,0-0.003,0-0.004,0H272c-4.417-0.001-7.999,3.579-8,7.996c0,0.001,0,0.003,0,0.004v16h-48 c-2.809,0.001-5.412,1.475-6.859,3.883l-24,40C184.394,69.126,184,70.549,184,72v48c-0.001,4.417,3.579,7.999,7.996,8 c0.001,0,0.003,0,0.004,0h16c0,13.255,10.745,24,24,24s24-10.745,24-24h88c0,13.255,10.745,24,24,24s24-10.745,24-24h24 c4.417,0.001,7.999-3.579,8-7.996c0-0.001,0-0.003,0-0.004V8C424.001,3.583,420.421,0.001,416.004,0z M220.531,40H232v16h-21.069 L220.531,40z M232,136c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8C239.996,132.416,236.416,135.996,232,136z M264,112h-14.242 c-8.676-9.807-23.659-10.725-33.467-2.049c-0.724,0.641-1.408,1.325-2.049,2.049H200V74.219L201.331,72H240 c4.417,0.001,7.999-3.579,8-7.996c0-0.001,0-0.003,0-0.004V40h16V112z M368,136c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8 C375.996,132.416,372.416,135.996,368,136z M408,112h-22.242c-8.676-9.807-23.659-10.725-33.467-2.049 c-0.724,0.641-1.408,1.325-2.049,2.049H280V16h128V112z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 24,
    width: 40,
    height: 16,
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 56,
    width: 40,
    height: 16,
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 88,
    width: 40,
    height: 16,
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360,192H64c-26.51,0-48-21.49-48-48c0-26.51,21.49-48,48-48h104V80H64c-35.346,0-64,28.654-64,64 c0,35.346,28.654,64,64,64h296c57.438,0,104,46.562,104,104s-46.562,104-104,104H224v16h136c66.274,0,120-53.726,120-120 S426.274,192,360,192z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.004,384c-0.001,0-0.003,0-0.004,0H40c-4.417-0.001-7.999,3.579-8,7.996c0,0.001,0,0.003,0,0.004v32 c-0.001,4.417,3.579,7.999,7.996,8c0.001,0,0.003,0,0.004,0h48c4.417,0.001,7.999-3.579,8-7.996c0-0.001,0-0.003,0-0.004v-32 C96.001,387.583,92.421,384.001,88.004,384z M80,416H48v-16h32V416z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.004,272c-0.001,0-0.003,0-0.004,0H8c-4.417-0.001-7.999,3.579-8,7.996c0,0.001,0,0.003,0,0.004v192 c-0.001,4.417,3.579,7.999,7.996,8c0.001,0,0.003,0,0.004,0h192c4.417,0.001,7.999-3.579,8-7.996c0-0.001,0-0.003,0-0.004V280 C208.001,275.583,204.421,272.001,200.004,272z M112,288h32v40c0,8.837-7.163,16-16,16s-16-7.163-16-16V288z M64,288h32v40 c0,8.837-7.163,16-16,16s-16-7.163-16-16V288z M16,288h32v40c0,8.837-7.163,16-16,16s-16-7.163-16-16V288z M160,464h-24v-40h24 V464z M192,464h-16v-48c0.001-4.417-3.579-7.999-7.996-8c-0.001,0-0.003,0-0.004,0h-40c-4.417-0.001-7.999,3.579-8,7.996 c0,0.001,0,0.003,0,0.004v48H16V355.549c13.155,7.874,30.076,5.079,40-6.607c11.331,13.255,31.262,14.814,44.517,3.483 c1.25-1.069,2.415-2.233,3.483-3.483c11.331,13.255,31.262,14.814,44.517,3.483c1.25-1.069,2.415-2.233,3.483-3.483 c9.924,11.686,26.845,14.481,40,6.607V464z M192,328c0,8.837-7.163,16-16,16s-16-7.163-16-16v-40h32V328z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportLogistics);
export default __webpack_public_path__ + "static/media/transport_logistics.fb9381bb370c0567836337c6225db50c.svg";
export { ForwardRef as ReactComponent };